/**
 * Simula uma fila de jobs após salvar notas V1/V2 / ocorrências:
 * pending → success (App faz poll a cada 2s).
 */

import { registerDemoJob } from "./demoJobHistory";

let phase = "idle";
let lastJob = null;

export function notifyDemoGradesV2JobPosted(body) {
  if (!body || !body.filter) {
    return;
  }
  const { filter, classId } = body;
  const { period } = filter;
  const course = filter.course || {};
  phase = "pending";
  lastJob = {
    id: "demo-grades-v2-job",
    status: "pending",
    name: "save_grades",
    title: `Turma ${classId} | Disciplina ${course.id} - ${period}`,
    classId,
    course: course.id,
    period,
    payload: body
  };
  registerDemoJob(lastJob);
}

/** Notas V1 — mesma fila save_grades do V2. */
export function notifyDemoGradesV1JobPosted(body) {
  if (!body) {
    return;
  }
  const { filter, classId } = body;
  const period = (filter && filter.period) || `${body.idStep}-${body.idExam}`;
  const course = (filter && filter.course) || {};
  const courseId = course.id != null ? course.id : body.idTurmaDisc;
  phase = "pending";
  lastJob = {
    id: `demo-grades-v1-job-${Date.now()}`,
    status: "pending",
    name: "save_grades",
    title: `Turma ${classId} | Disciplina ${courseId} - ${period}`,
    classId,
    course: courseId,
    period,
    payload: body
  };
  registerDemoJob(lastJob);
}

export function notifyDemoOccurrenceJobPosted(body) {
  if (!body) {
    return;
  }
  const classId = body.classId || null;
  const filter = body.filter || {};
  const course = filter.course || {};
  const period = filter.period || null;
  phase = "pending";
  lastJob = {
    id: `demo-occurrences-job-${Date.now()}`,
    status: "pending",
    name: "save_occurrences",
    title: classId ? `Turma ${classId} | Ocorrências` : "Ocorrências",
    classId,
    course: course.id != null ? course.id : undefined,
    period
  };
  registerDemoJob(lastJob);
}

export function notifyDemoClassStageJobPosted(classId, body) {
  phase = "pending";
  lastJob = {
    id: `demo-class-stage-job-${Date.now()}`,
    status: "pending",
    name: "save_class_stage",
    title: `Turma ${classId} | ${(body && body.title) || ""}`,
    classId
  };
  registerDemoJob(lastJob);
}

export function takeDemoGradeJobsResponse() {
  if (phase === "idle" || !lastJob) {
    return [];
  }
  if (phase === "pending") {
    phase = "await_success";
    registerDemoJob({ ...lastJob, status: "pending" });
    return [
      {
        ...lastJob,
        status: "pending"
      }
    ];
  }
  if (phase === "await_success") {
    const done = { ...lastJob, status: "success" };
    registerDemoJob(done);
    phase = "idle";
    lastJob = null;
    return [done];
  }
  return [];
}
